import { useCallback } from "react";

import type { ColumnSelectionOptions } from "app/pages/sales-intelligence/common-components/column-picker";
import { fromDtoToColumnOptions } from "app/pages/sales-intelligence/modules/leads-search/utils";
import { getColumnConfig } from "app/pages/sales-intelligence/pages/find-apps/configuration/columns/columnConfig";
import { useColumnsConfigQuery } from "app/pages/sales-intelligence/pages/find-apps/queries/useColumnsConfigQuery";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { AppsColumnConfigDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";

type HookValue = [readonly string[], ColumnSelectionOptions];

const DEFAULT_OPTIONS: HookValue = [[], []];

const useColumnSelectionOptions = (appSourceType: AppsSourceType): HookValue => {
    const columnConfig = getColumnConfig(appSourceType);

    const transformData = useCallback(
        ({ selected, available }: AppsColumnConfigDto): HookValue => {
            const transformedAvailable = fromDtoToColumnOptions(available, columnConfig);

            return [selected, transformedAvailable];
        },
        [columnConfig],
    );

    const { data } = useColumnsConfigQuery(appSourceType, transformData);

    return data ?? DEFAULT_OPTIONS;
};

export default useColumnSelectionOptions;
